// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exercise-access h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

/* Top controls section */
.exercise-selector-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.exercise-selector-group label {
  margin: 0;
  white-space: nowrap;
}

.exercise-select-inline {
  flex: 1 1;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  transition: border-color 0.2s;
}

.exercise-select-inline:focus {
  outline: none;
  border-color: #3498db;
}

.group-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

/* Card header with filters */
.card-header-with-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.card-header-with-filters h2 {
  margin: 0;
}

.filters-section {
  display: flex;
  gap: 0.5rem;
  flex: 1 1;
  max-width: 600px;
  min-width: 300px;
}

.search-input {
  flex: 1 1;
  padding: 0.5rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.95rem;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3498db;
}

.group-filter {
  min-width: 150px;
  padding: 0.5rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.95rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.group-filter:focus {
  outline: none;
  border-color: #3498db;
}

.group-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.btn-sm {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #e74c3c;
}

.modal-content p {
  margin-bottom: 1rem;
  color: #555;
  line-height: 1.6;
}

.modal-buttons {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.modal-buttons .btn {
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/teacher/ExerciseAccess.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".exercise-access h1 {\r\n  margin-bottom: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n/* Top controls section */\r\n.exercise-selector-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.exercise-selector-group label {\r\n  margin: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.exercise-select-inline {\r\n  flex: 1;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  background: white;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.exercise-select-inline:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.group-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n/* Card header with filters */\r\n.card-header-with-filters {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1.5rem;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.card-header-with-filters h2 {\r\n  margin: 0;\r\n}\r\n\r\n.filters-section {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex: 1;\r\n  max-width: 600px;\r\n  min-width: 300px;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  padding: 0.5rem 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.group-filter {\r\n  min-width: 150px;\r\n  padding: 0.5rem 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.group-filter:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.group-buttons {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn-sm {\r\n  padding: 0.25rem 0.75rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 8px;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.modal-content h3 {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n  color: #e74c3c;\r\n}\r\n\r\n.modal-content p {\r\n  margin-bottom: 1rem;\r\n  color: #555;\r\n  line-height: 1.6;\r\n}\r\n\r\n.modal-buttons {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.modal-buttons .btn {\r\n  min-width: 120px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
